var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3262_41868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.91384 3.36384L17.4988 10.0022L3.91384 16.6405C3.8363 16.6703 3.75165 16.6764 3.67064 16.658C3.58963 16.6396 3.51591 16.5975 3.45884 16.5372C3.4001 16.4752 3.35967 16.3982 3.34202 16.3146C3.32437 16.2311 3.33019 16.1443 3.35884 16.0638L5.41551 10.0022L3.35884 3.94051C3.33019 3.86007 3.32437 3.77327 3.34202 3.68972C3.35967 3.60618 3.4001 3.52915 3.45884 3.46717C3.51591 3.4068 3.58963 3.36474 3.67064 3.34635C3.75165 3.32795 3.8363 3.33404 3.91384 3.36384Z",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41797 10H17.5013",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3262_41868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.302ad43f4279289370fea6a324372f9f.svg";
export { ForwardRef as ReactComponent };